document.addEventListener('DOMContentLoaded', function () {
  const categoryItems = document.querySelectorAll('.category-item');

  // Prüfen, ob das Gerät ein Touchscreen hat
  const isTouchDevice = () => {
    return ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  };

  // Nur auf Nicht-Touch-Geräten Videos laden und abspielen
  if (!isTouchDevice()) {
    const preloadAndPlayVideos = () => {
      categoryItems.forEach(item => {
        const video = item.querySelector('video');
        if (video) {
          video.preload = 'auto';
          video.muted = true;
          video.playsInline = true;

          if (isInViewport(video)) {
            playVideo(video);
          }
        }
      });
    };

    const playVideo = (video) => {
      if (video && video.paused) {
        video.play().catch(error => console.error("Autoplay fehlgeschlagen:", error));
      }
    };

    const pauseVideo = (video) => {
      if (video && !video.paused) {
        video.pause();
      }
    };

    const isInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    window.addEventListener('scroll', () => {
      categoryItems.forEach(item => {
        const video = item.querySelector('video');
        if (video) {
          if (isInViewport(video)) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        }
      });
    });

    preloadAndPlayVideos();
  } else {
    // Videos entfernen auf Touch-Geräten
    categoryItems.forEach(item => {
      const video = item.querySelector('video');
      if (video) {
        video.remove();
      }
    });
  }
});


